import styles from "./ContactSelector.module.scss";

const ContactListItem = ({ contact, isSelected, onToggle, isRemoveMode = false }) => {
  const getActivityLevel = (rfqs7d) => {
    if (rfqs7d > 5) return 'high';
    if (rfqs7d > 0) return 'medium';
    return 'low';
  };

  const activityLevel = getActivityLevel(contact.rfqs_7d);

  return (
    <div className={styles.contactItem}>
      <div className={styles.contactCheckbox}>
        {isRemoveMode ? (
          <button
            className={styles.removeButton}
            onClick={() => onToggle(contact.id)}
            type="button"
          >
            ×
          </button>
        ) : (
          <button
            className={`${styles.checkButton} ${isSelected ? styles.selected : ''}`}
            onClick={() => onToggle(contact.id)}
            type="button"
          >
            ✓
          </button>
        )}
      </div>
      
      <div className={styles.contactInfo}>
        {contact.name && (
          <div className={styles.contactName}>
            {contact.name}
          </div>
        )}
        {contact.email && (
          <div className={styles.contactEmail}>
            {contact.email}
          </div>
        )}
        {contact.phone && (
          <div className={styles.contactPhone}>
            {contact.phone}
          </div>
        )}
        {contact.customer_name && (
          <div className={styles.customerName}>
            {contact.customer_name.length > 35
              ? `${contact.customer_name.substring(0, 35)}...`
              : contact.customer_name}
          </div>
        )}
      </div>

      <div className={styles.activitySection}>
        <div className={styles.rfqStats}>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{contact.rfqs_7d || 0}</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{contact.rfqs_30d || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactListItem;